import { render, staticRenderFns } from "./sim-profile.vue?vue&type=template&id=dc1bebf6&"
import script from "./sim-profile.vue?vue&type=script&lang=js&"
export * from "./sim-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports